export default __webpack_public_path__ + "static/media/dontfreeze_demo_image.1955e0eb.png";